
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from "@/components/ui/card";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
import type { PerformanceData } from "./types";

interface RecruiterPerformanceOverviewChartProps {
  data: PerformanceData[];
}

export const RecruiterPerformanceOverviewChart = ({ data }: RecruiterPerformanceOverviewChartProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recruiter Performance Overview</CardTitle>
        <CardDescription>Key metrics by recruiter</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
              layout="vertical"
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" />
              <YAxis
                dataKey="name"
                type="category"
                width={100}
              />
              <Tooltip />
              <Legend />
              <Bar
                dataKey="candidates"
                name="Total Candidates"
                fill="#9b87f5"
                barSize={20}
              />
              <Bar
                dataKey="interviews"
                name="Interviews"
                fill="#7E69AB"
                barSize={20}
              />
              <Bar
                dataKey="hired"
                name="Placements"
                fill="#33C3F0"
                barSize={20}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};
